import { Flex, VStack } from "@chakra-ui/react";
import { MessageTemplate } from "features/Resources/MessageTemplate/models";
import { ShowTrigger } from "features/Resources/Shared/Components/Fields/TriggerField";
import { ShowPrebuiltPaths } from "features/Resources/Shared/Components/Fields/PathsField";
import { ShowName } from "features/Resources/Shared/Components/Fields/NameField";
import { ActionTypeTag } from "design-system";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";
import { ShowRecordTarget } from "features/Resources/Shared/Components/Fields/RecordTargetField";

export default function PrebuiltMessageTemplateDisplay({
  prebuiltMessageTemplate,
}: {
  prebuiltMessageTemplate: MessageTemplate;
}) {
  return (
    <VStack spacing={4} align="stretch" width="100%">
      <Flex w="100%" justify="space-between" align="center" height="40px">
        <ShowName name={prebuiltMessageTemplate?.name} />
        <ActionTypeTag.Badge actionType="message" />
      </Flex>
      <ShowPrebuiltPaths prebuiltPathIds={prebuiltMessageTemplate?.pathIds} />
      <ShowRecordTarget recordTarget={prebuiltMessageTemplate?.recipient} label="To" />
      <ShowTrigger label="Send At" trigger={prebuiltMessageTemplate?.deliverAtTrigger} />
      <ShowRichText label="Message" richText={prebuiltMessageTemplate.bodyDisplay ?? prebuiltMessageTemplate.body} />
    </VStack>
  );
}
